module.exports = __webpack_public_path__ + "static/img/tab.fa40cf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/common/tab.jpg
// module id = Khp0
// module chunks = 11 18